// NewProjectModalEnhanced.jsx
import React, { useState, useEffect, useRef } from "react";
import { useCurrentTenant } from "../../hooks/useCurrentTenant";
import "./NewProjectModalEnhanced.css"; // reuses old modal CSS class names

export default function NewProjectModalEnhanced({ onCreate, onClose, scenarios = [] }) {
  const currentTenantId = useCurrentTenant();
  const [name, setName] = useState("");
  const defaultScenario = scenarios.find((sc) => sc.isDefault) ?? null;
  const [scenarioId, setScenarioId] = useState("");
  const touched = useRef(false);
  const canCreate = name.trim().length > 0;

  useEffect(() => {
    if (!touched.current && defaultScenario) setScenarioId(defaultScenario.id);
  }, [defaultScenario?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const handleCreate = async () => {
    if (!canCreate) return;

    await onCreate?.({
      name: name.trim(),
      scenarioId: scenarioId || defaultScenario?.id || "",
    });

    onClose?.();
  };


  return (
    <div className="modal-backdrop">
      <div className="modal-content modal-small">

        <h2 className="modal-title">Create New Project</h2>

        {/* Project Name Input */}
        <label className="modal-label">
          <input
            type="text"
            className="modal-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Project name"
          />
        </label>


        {/* Scenario Dropdown */}
        <label className="modal-label">
          Scenario
          <select
            className="modal-input"
            value={scenarioId}
            onChange={e => setScenarioId(e.target.value)}
          >
            <option value="">— Select a Scenario —</option>

            {scenarios.map(sc => (
              <option key={sc.id} value={sc.id}>{sc.name}{sc.isDefault ? " (default)" : ""}</option>
            ))}
          </select>
        </label>


        {/* Buttons */}
        <div className="modal-actions">
          <button
            className="btn-primary"
            disabled={!canCreate}
            onClick={handleCreate}
          >
            ✅ Create
          </button>

          <button className="btn--cancel-projectmodal" onClick={onClose}>
            ❌ Cancel
          </button>
        </div>

      </div>
    </div>
  );
}